import { Mui } from "@osu/react-ui";
import { shallowEqual, useSelector } from "react-redux";
import { selectFormTypeOptionsForSession } from "../../../../services/submissionPeriod/slices";
import { useState } from "react";
import { mergeSxStyles } from "../../../../util/functions";

function SelectFormType({ id = "select-form-type-for-export", name = "form-type-to-download", session, sx, ...rest }) {
  const formTypes = useSelector(state => selectFormTypeOptionsForSession(state, session), shallowEqual);
  const [formType, setFormType] = useState(formTypes?.[0]?.value || "");

  const handleChange = (event) => {
    setFormType(event.target.value);
  };

  const labelId = id + "-label";

  return (
    <Mui.FormControl  sx={mergeSxStyles(sx, { minWidth: "15rem" })} {...rest}>
      <Mui.InputLabel sx={{ 
        minWidth: "15rem"
      }} id={labelId}>Form Type</Mui.InputLabel>
      <Mui.Select
        labelId={labelId}
        id={id}
        value={formType}
        label="Form Type"
        onChange={handleChange}
        name={name}
        required
      >
        {formTypes.map(({ label, value }, idx) => (
          <Mui.MenuItem key={`${value}-${idx}`} value={value}>
            {label}
          </Mui.MenuItem>
        ))}
      </Mui.Select>
    </Mui.FormControl>
  );
}

export default SelectFormType;
